import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';

export const LightboxSlideFooter = styled(MUIBox)(() => ({
  position: 'fixed',
  bottom: '10px',
  color: 'white',
}));
